export const hasAccess = (profileActive, profiles: string[]) => {
  return profileActive
    ? profiles.some((profile) => profile === profileActive.ID_PERFIL)
    : true;
};

export const arrayToAPI = (
  array: { value: string; label: string; active: string }[]
) => {
  return array.map((item) => item.value).join(',');
};

export const monthArrayToAPI = (
  array: { value: string; label: string; active: string }[]
) => {
  return array.map((item) => Number(item.value) - 1).join(',');
};
